import { IObjectStore } from '@shared/service/Indexeddb/IObjectStore';
import { IFrameStore } from '@rift/service/validation/database/syncrecording/IFrameStore';

export interface IDatabaseGlobalBookmarkFramesStore extends IFrameStore {
}

export class DatabaseGlobalBookmarkFramesStore implements IObjectStore {
    public static readonly keyPath: string = 'id';
    public static readonly recordingIdBlockIndex: string = 'RecordingIdBlockIndex';
    public static readonly recordingIdFrameNumberIndex: string = 'RecordingIdFrameNumberIndex';
    public static readonly recordingIdIndex: string = 'RecordingIdIndex';
    public static readonly storeDisplayName: string = 'Bookmark';
    public static readonly storeName: string = 'bookmark';

    public get storeName(): string {
        return DatabaseGlobalBookmarkFramesStore.storeName
    };

    public static toInterface(): IDatabaseGlobalBookmarkFramesStore {
        return {
            storeName: this.storeName,
            keyPath: this.keyPath,
            recordingIdFrameNumberIndex: this.recordingIdFrameNumberIndex,
            recordingIdIndex: this.recordingIdIndex,
            recordingIdBlockIndex: this.recordingIdBlockIndex,
        } as IDatabaseGlobalBookmarkFramesStore;
    }

    public createStores(db: IDBDatabase): void {
        const store: IDBObjectStore = db.createObjectStore(DatabaseGlobalBookmarkFramesStore.storeName, { keyPath: DatabaseGlobalBookmarkFramesStore.keyPath, autoIncrement: true });
        store.createIndex(DatabaseGlobalBookmarkFramesStore.recordingIdFrameNumberIndex, ['recordingId', 'frameNumber'], { unique: true });
        store.createIndex(DatabaseGlobalBookmarkFramesStore.recordingIdBlockIndex, ['recordingId', 'block']);
        store.createIndex(DatabaseGlobalBookmarkFramesStore.recordingIdIndex, 'recordingId');
    }
}
